import { Icons } from '@Assets/SvgIcons';
import { RouteEnums } from '@Helper/Enums';
import { dealspaceUserIsOwner } from '@Helper/utils';
import { Button, Dialog } from '@mui/material';
import { getUserDealspaceList } from '@Store/feature/dealspaceSlice';
import { useAppSelector } from '@Store/hooks';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
interface IProps {
  showModal: boolean;
  setShowModal: () => void;
}

export default function TrialEndModal({ showModal, setShowModal }: IProps) {
  let navigate = useNavigate();
  const userDealspaceList = useAppSelector(getUserDealspaceList);
  const { id } = useParams();

  const [freeTrialModalVisible, setFreeTrialModalVisible] =
    useState<boolean>(showModal);

  const [noModalVisible, setNoModalVisible] = useState<boolean>(false);
  const onClose = () => {
    setShowModal();
    setFreeTrialModalVisible(false);
  };
  const goPaymentAccount = () => {
    setShowModal();
    navigate(RouteEnums.PaymentPlan, { state: { dealspaceId: id } });
  };
  useEffect(() => {
    setFreeTrialModalVisible(showModal);
  }, [showModal]);

  return (
    <>
      <Dialog
        open={freeTrialModalVisible}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="WorkstreamsCard-func-dialog free-dialog"
      >
        <div className="dialog-header">
          <div className="dialog-title ftm-title danger">Trial expired!</div>
          <button className="dialog-close-button" onClick={onClose}>
            <Icons.Cancel color="#000000" />
          </button>
        </div>
        <div className="dialog-content" style={{ flex: 1 }}>
          <div
            className="free-title-2"
            style={{ marginBottom: '16px', fontSize: 16 }}
          >
            We hope you enjoyed using Mergeflo this past month to work more
            efficiently, effectively and collaboratively.
          </div>
          <div className="free-title-2" style={{ fontSize: 16 }}>
            You have reached the end of the free trial, if you'd like to
            continue working with your team, please upgrade your plan.
          </div>
          <div className="free-about">
            <div
              className="free-date"
              style={{ fontSize: 32, marginBottom: 20, marginTop: 10 }}
            >
              Expired on:{' '}
              {moment(
                userDealspaceList?.find(i => i.id === (id ?? ''))?.trialEndDate
              ).format('ll')}
            </div>
          </div>
          <div className="about-dashed-red">
            <div
              style={{
                width: '28px',
                marginRight: 20,
                marginTop: 5,
              }}
            >
              <Icons.Lightbulb />
            </div>
            <div>
              If you are not ready to work with your team yet, we recommend
              downgrading to the free plan to save your data.
            </div>
          </div>
        </div>
        <div className="dialog-footer">
          <button
            className="dashed-btn"
            style={{ marginRight: 15, padding: '8px 20px' }}
            onClick={() => {
              setFreeTrialModalVisible(false);
              setNoModalVisible(true);
            }}
          >
            Not yet
          </button>
          <Button
            className="FuchsiaBlueButton"
            style={{ width: 213, fontWeight: '600' }}
            onClick={goPaymentAccount}
            disabled={
              userDealspaceList && id
                ? dealspaceUserIsOwner(userDealspaceList, id)
                : false
            }
          >
            {userDealspaceList &&
            id &&
            dealspaceUserIsOwner(userDealspaceList, id) ? (
              <span>Contact The Owner </span>
            ) : (
              <span>Choose plan </span>
            )}
          </Button>
        </div>
      </Dialog>

      <Dialog
        open={noModalVisible}
        onClose={() => setNoModalVisible(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="WorkstreamsCard-func-dialog no-trial-dialog"
      >
        <div className="dialog-header">
          <div className="dialog-title ftm-title danger">
            Tool paused - read only
          </div>
        </div>
        <div className="dialog-content" style={{ flex: 1 }}>
          <div className="free-title-2">
            As a heads up, a plan decision will need to be made to continue
            using the features of Mergeflo. You will notice your data is saved
            with us however your ability to interact with it is limited until a
            plan decision is made.
          </div>

          <div className="free-title-2" style={{ marginTop: 30 }}>
            For any questions, please contact katherine@mergeflo.com.
          </div>
        </div>
        <div className="dialog-footer" style={{ justifyContent: 'center' }}>
          <Button
            className="FuchsiaBlueButton"
            style={{ width: 190, fontWeight: '600' }}
            onClick={() => setNoModalVisible(false)}
          >
            <span>Close</span>
          </Button>
        </div>
      </Dialog>
    </>
  );
}
